'use client';

import { AnimatePresence, motion } from 'motion/react';
import { cn } from '~/utils';
import { ActivityFilterBar } from './client';
import { useActivitySearchMode } from './useActivitySearchMode';

type FilterBarProps = React.ComponentProps<typeof ActivityFilterBar>;

type ActivitySearchFiltersRegionProps = FilterBarProps;

/**
 * Shows the regular filter pill in `normal` mode. In `ai` mode it renders nothing: the AI
 * composer lives in the always-open results sidebar (`ActivityAiChatPanel`), so the hero pill
 * area is intentionally empty (ADR 0006). The mode tab strip itself lives in
 * {@link ActivitySearchModeTabBar}.
 */
export const ActivitySearchFiltersRegion: React.FC<ActivitySearchFiltersRegionProps> = props => {
    const { mode } = useActivitySearchMode();

    return (
        <div
            className={cn('relative z-2 flex w-full flex-col items-center', props.wrapperClassName)}
        >
            <div className="relative w-full outline-none" role="presentation">
                <AnimatePresence mode="wait" initial={false}>
                    {mode === 'normal' ? (
                        <motion.div
                            key="activity-search-surface-normal"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.1, ease: 'easeOut' }}
                            className="w-full"
                        >
                            <ActivityFilterBar
                                variant={props.variant}
                                backgroundType={props.backgroundType}
                                wrapperClassName={undefined}
                                className={props.className}
                                compact={props.compact}
                            />
                        </motion.div>
                    ) : null}
                </AnimatePresence>
            </div>
        </div>
    );
};
